module.exports = __webpack_public_path__ + "flightIcon-26a5faefb42a171a3a0b8d8ae95fe9b9.png";